import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import moment from 'moment';
import PromoMessage from '../../promo-message';

class Component extends BaseComponent {
    render({ route }) {
        if (route != 'everyone') {
            return this.renderForYou();
        }

        return this.renderForEveryone();
    }

    renderForYou = () => {
        if (this.props.logged_in && this.props.tcod && this.props.tcod.you) {
            return (
                <daily-tarot-card-mobile>
                    {this.renderDailyLinks()}
                    <h1>Tarot Card of the Day</h1>
                    {this.renderTCOD(this.props.tcod.you)}
                </daily-tarot-card-mobile>
            );
        }

        return (
            <daily-tarot-card-mobile>
                {this.renderDailyLinks()}
                <h1>Tarot Card of the Day</h1>
                <a href='/signup?return'>
                    <img
                      src='https://gfx.tarot.com/images/daily-pages/daily-icons/tarot.svg'
                      alt='Unknown Tarot Card'
                    />
                </a>
                <h2>Create Your Profile To Find Out!</h2>
                <p>
                    Looking for your Tarot Card of the Day? Create your profile to receive a Tarot card that's
                    personalized to YOU every day!
                </p>
                <a href='/signup?return' class='button'>CREATE MY PROFILE</a>
                <p>Already a Tarot.com member? <a href='/login'>Login Now</a></p>
            </daily-tarot-card-mobile>
        );
    }

    renderForEveryone = () => {
        if (this.props.tcod && this.props.tcod.everyone) {
            return (
                <daily-tarot-card-mobile>
                    {this.renderDailyLinks()}
                    <h1>Tarot Card of the Day</h1>
                    {this.renderTCOD(this.props.tcod.everyone)}
                </daily-tarot-card-mobile>
            );
        }

        return (
            <daily-tarot-card-mobile />
        );
    }

    renderDailyLinks = () => {
        return (
            <div class='daily-links'>
                <a href='#everyone' class={this.props.route == 'everyone' ? 'selected' : ''}>FOR EVERYONE</a>
                <a href='#you' class={this.props.route != 'everyone' ? 'selected' : ''}>FOR YOU</a>
            </div>
        );
    }

    renderTCOD = (tcod) => {
        if (tcod) {
            const img_url = `https://gfx.tarot.com/images/site/decks/${tcod.deck_code}/full_size/${tcod.card_id}.jpg`;

            return (
                <div>
                    <p class='has-text-centered'>
                        <a href={`/tarot/cards/${tcod.card.canonical_rank}/${tcod.deck_code}`} target='_blank'>
                            <img src={img_url} alt={tcod.card.name} />
                        </a>
                    </p>
                    <small>
                        <a href={`/tarot/decks/${tcod.deck_code}`}>{tcod.deck.name}</a> deck © U.S. Games Systems, Inc.
                    </small>
                    <br />
                    {tcod.interp_body.map((p, key) => {
                        if (key == 0) {
                            return (
                                <p>
                                    <b>{moment(this.props.date).format('M.D.YY')} {tcod.card.name}: </b>
                                    {p}
                                </p>
                            );
                        }
                        return (<p>{p}</p>);

                    })}
                    <p><PromoMessage placement='text-tarot' /></p>
                </div>
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    tcod: state.tcod,
    logged_in: state.user && state.user.logged_in,
    route: state.route,
});

export default connect(mapStateToProps)(Component);


// WEBPACK FOOTER //
// ./app/components/daily/tarot-card/mobile.js